import $http from "../plugins/axios";
import store from "../store/store";
import ActionTypes from "../store/ActionTypes";
import i18n from '../plugins/i18n.js'
const _ = require('lodash');

const UserService = {
    getBotList() {
        return $http.get(`/live-support/get-user-bots/`)
    },
    getPinnedBotList() {
        return $http.get('/live-support/user-pin-bots/')
    },
    getUserConfig() {
        return $http.get('/live-support/user-config/')
    },
    pinBot(botCode, isPin = true) {
        return $http.post('/live-support/user-pin-bots/', {
            "pin": isPin,
            "bot_code": botCode
        });
    },
    enableNotify(botCode) {
        return $http.post(`/live-support/user-config/enable-notify/${botCode}`)
    },
    disableNotify(botCode) {
        return $http.post(`/live-support/user-config/disable-notify/${botCode}`)
    },
    updateBotListPin(botCodeListPin) {
        if (Array.isArray(botCodeListPin)) {
            let botListPin = [];
            if (botCodeListPin.length > 0) {
                let botList = store.state.botList;
                botCodeListPin = _.uniq(botCodeListPin);
                for (let botCode of botCodeListPin) {
                    let bot = _.find(botList, bot => bot.code === botCode);
                    if (bot) {
                        botListPin.push(bot);
                    }
                }
            }
            store.commit(ActionTypes.BOT_LIST_PIN, botListPin);
        }
    },
    /**
     *<pre>
     *filter= {
     *  read_status: boolean,
     *  text_filter: string,
     *  created_time_from: Date.toISOString() ex  "2020-11-16T04:33:21.163Z",
     *  created_time_to: Date.toISOString() ex  "2020-11-16T04:33:21.163Z"
     * }
     * </pre>
     */
    getUserNotifies(filter, page, page_size) {
        if (!page) {
            page = 1;
        }
        if (!page_size) {
            page_size = 10;
        }
        let url = `/live-support/user-notify/list/?page=${page}&page_size=${page_size}`;
        if (!filter) {
            filter = {}
        }
        if (filter.read_status === true || filter.read_status === false) {
            url += `&read_status=${filter.read_status}`;
        }
        if (filter.text_filter) {
            url += `&text_filter=${filter.text_filter}`;
        }
        if (filter.type_filter) {
            url += `&type_filter=${filter.type_filter}`;
        }
        if (filter.created_time_from) {
            url += `&created_time_from=${filter.created_time_from}`;
        }
        if (filter.created_time_to) {
            url += `&created_time_to=${filter.created_time_to}`;
        }
        return $http.get(url)
    },
    /**
     * @param notify_ids String array
     * @param read_status Boolean
     */
    updateUserNotifyReadStatus(notify_ids, read_status) {
        return $http.put("/live-support/user-notify/update-read-status/", {notify_ids, read_status})
    },
    format_notify_message(notify) {
        let formatted_msg = notify.content, message = notify.content,
            extra_data = notify.extra_data || {}, vue_i18n_template = extra_data.vue_i18n_template,
            bot_name = (extra_data.bot_name || "").replaceAll("<", "").replaceAll(">", "").replaceAll("&", ""),
            sender_name = (extra_data.sender_name || "").replaceAll("<", "").replaceAll(">", "").replaceAll("&", "");

        if (vue_i18n_template) {
            message = i18n.t(vue_i18n_template, {...extra_data, bot_name, sender_name})
            formatted_msg = i18n.t(vue_i18n_template, {...extra_data, bot_name, sender_name: `<b>${sender_name}</b>`})
        } else {
            message = formatted_msg.replace(/\${bot_name}/g, bot_name).replace(/\${sender_name}/g, sender_name);
            formatted_msg = formatted_msg.replace(/\${bot_name}/g, bot_name).replace(/\${sender_name}/g, `<b>${sender_name}</b>`);
        }

        const notifyId = notify ? notify._id : '';
        return {formatted_msg, message, notifyId};
    },
    getLatestUserNotifies(type_filter) {
        let url = `/live-support/user-notify/latest-unread-notify/?type_filter=${type_filter || ""}`;
        return $http.get(url)
    },
    callMarkAllAsRead(notifies) {
        return $http.put("/live-support/user-notify/mark-all-as-read/", {notifies})
    },
};

export default UserService
